import React from "react";
import "./CompactAppointmentForm.css";

const insights = [
  {
    label: "Today’s Bookings",
    value: "32",
    trend: "+8% vs yesterday",
  },
  {
    label: "Average Wait",
    value: "14 min",
    trend: "steady flow",
  },
  {
    label: "Consult Rooms",
    value: "5 / 6",
    trend: "active",
  },
];

const flows = [
  { icon: "🌿", title: "Intake", desc: "Vitals & prakriti capture" },
  { icon: "🧪", title: "Diagnostics", desc: "Pulse, tongue, dosha check" },
  { icon: "💆", title: "Therapy", desc: "Curated herbs & care" },
  { icon: "🧘", title: "Follow-up", desc: "Lifestyle cues & handoffs" },
];

const CompactAppointmentForm = () => {
  return (
    <div className="ashtang-dashboard">
      <div className="dashboard-frame">
        <section className="dashboard-hero">
          <div>
            <p className="hero-pill">Ashtang care hub</p>
            <h1>
              Calm oversight,
              <span> meaningful outcomes.</span>
            </h1>
            <p>
              Track appointments, monitor room readiness, and keep every healing
              journey moving with confidence.
            </p>
          </div>

          <div className="hero-highlights">
            <div>
              <span>OPD Flow</span>
              <strong>On schedule</strong>
            </div>
            <div>
              <span>Next peak</span>
              <strong>4:30 PM</strong>
            </div>
          </div>
        </section>

        <section className="insights-grid">
          {insights.map((item) => (
            <article key={item.label} className="insight-card">
              <p>{item.label}</p>
              <h3>{item.value}</h3>
              <span>{item.trend}</span>
            </article>
          ))}
        </section>

        <section className="flow-panel">
          <header>
            <h2>Patient journey</h2>
            <p>Snapshot of the live care loop</p>
          </header>
          <div className="flow-grid">
            {flows.map((step) => (
              <div key={step.title} className="flow-card">
                <div className="flow-icon">{step.icon}</div>
                <div>
                  <h4>{step.title}</h4>
                  <p>{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="support-strip">
          <div>
            <p>Ashtang Ayurveda Superspecialist Hospital</p>
            <span>Rane Nagar, Nashik</span>
          </div>
          <div>
            <p>Front desk</p>
            <strong>+91 87930 00341</strong>
          </div>
          <div>
            <p>Hours</p>
            <strong>07:00 AM — 07:00 PM</strong>
          </div>
        </section>
      </div>
    </div>
  );
};

export default CompactAppointmentForm;